<template>
  <card>
    <list
      v-if="$store.state.user.sections['subscriptions']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :params="params"
      :filters="filters"
      :dateFilter="dateFilter"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :projectInfo="1"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
    getDateIn12Months() {
      let today = new Date(); // get current dat
      today.setMonth(today.getMonth() + 11);
      return today.toISOString().slice(0, 10);
    },
    getFormattedDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  async created() {
    this.fields.push({
      col: "col-12 col-md-6",
      label: "Дата начала подписки",
      key: "start_date",
      labelKey: "start_date_credit",
      type: "field",
      readonly: true,
      textType: "date",
      default: this.getFormattedDate(),
    });
    this.fields.push({
      col: " col-12 col-md-6",
      key: "loan_period",
      labelKey: "loan_period",
      label: "Период подписки (мес.)",
      type: "static_radio",
      default: "12",
      items: [{ id: "12", title: "12 мес.", titleKey: "12month" }],
    });

    try {
      if (this.$store.state.user.is_system) {
        this.columns.push({
          key: "limit",
          title: "Лимит на 12",
          price: true,
        });
        this.columns.push({
          key: "limit_preview",
          title: "Лимит на 003",
          price: true,
        });
      }
    } catch (error) {}
  },
  data() {
    return {
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "status",
          title: "Фильтр по статусам",
          titleKey: "status_filter",
          field_key: "status",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по локациям",
          titleKey: "filter_shop",
          field_key: "shop",
          selectKey: "name",
        },
      ],
      date: null,
      params: {
        is_list: 1,
      },
      val: [],
      modalCreate: "season",
      staticFilters: [
        {
          title: "Фильтр по блокировке",
          key: "subscription_status",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "block",
              title: "Блокированы",
            },
            {
              id: "unblock",
              title: "Разблокировано",
            },
            {
              id: "detach",
              title: "Снято с контроля",
            },
            {
              id: "none",
              title: "Нет запросов",
            },
          ],
        },
      ],
      fields: [
        {
          col: "col-12 col-md-12",
          label: "Номер телефона клиента",
          key: "phone",
          labelKey: "phone_client",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_subscription",
      itemLink: "subscriptions",
      setLink: "subscriptions",
      columns: [
        {
          detail: true,
          // remove: true,
        },
        {
          key: "id",
          title: "ID",
          titleKey: "id",
        },
        {
          key: "state_display",
          title: "Статус контроля",
          titleKey: "state_control",
        },
        // {
        //   key: "subscription_status",
        //   title: "Статус блокировки",
        //   titleKey: "subscription_status",
        //   object: "status",
        //   disableLink: true,
        // },

        {
          key: "status",
          titleKey: "status",
          title: "Статус",
          object: "name",
          disableLink: true,
        },

        {
          key: "phone_control",
          titleKey: "phone_control",
          title: "Номер по тарифу",
        },
        // {
        //   key: "product_name",
        //   titleKey: "product_name",
        //   title: "Название товара",
        //   minWidth: true,
        // },
        // {
        //   key: "product_barcode",
        //   titleKey: "product_barcode",
        //   title: "Баркод товара",
        // },
        {
          key: "plan",
          titleKey: "plan_name",
          title: "Тарифф",
          full: true,
        },
        // {
        //   key: "imeis",
        //   titleKey: "imeis",
        //   title: "Имеи",
        //   object: "number",
        //   disableLink: true,
        //   full: true,
        // },

        {
          key: "user_fullname",
          titleKey: "client",
          title: "Покупатель",
          object: "phone",
          disableLink: true,
          full: true,
        },
        {
          key: "client",
          titleKey: "phone",
          title: "Покупатель",
          object: "phone",
          disableLink: true,
        },
        {
          key: "sign",
          titleKey: "sign",
          title: "Подпись договора",
          link: true,
        },
        {
          key: "start_date",
          titleKey: "start_date",
          title: "Дата договора",
          dateFormat: true,
        },

        {
          key: "insurance_polis_number",
          title: "Полис",
          titleKey: "polise",
        },
        {
          key: "limit_rate",
          title: "Р.",
          titleKey: "rate_subscription",
        },

        {
          key: "imeis",
          titleKey: "imeis",
          title: "Имеи",
          object: "status",
          disableLink: true,
          full: true,
        },

        {
          key: "user",
          titleKey: "employee",
          title: "Оператор",
          object: "name",
          disableLink: true,
          full: true,
        },

        {
          key: "shop",
          titleKey: "shop",
          title: "Магазин",
          object: "name",
          disableLink: true,
          full: true,
        },
        {
          detail: true,
          log: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
